<h1 mat-dialog-title>{{ data.title ?? 'Verplaatsen naar' }}</h1>

<mat-dialog-content class="flex! flex-col">
  <div class="-mx-6 py-2 border-y border-gray-200 overflow-auto scrollbar-width-thin">
    <div class="flex flex-col gap-8 min-h-70">
      <div class="px-6">
        @if (stack().length) {
          <div class="flex items-center min-h-10 mb-2">
            <button mat-icon-button (click)="navigatePrevious()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="w-min max-w-40 truncate block text-sm font-medium">{{
              selectedNode()?.label
            }}</span>
          </div>
        }

        <div class="grid gap-2">
          @for (group of groups(); track $index) {
            <div
              class="flex items-center bg-gray-200 rounded-lg p-2 pl-4 min-h-12 select-none hover:cursor-pointer hover:bg-gray-300 [.active]:bg-secondary-200 [.active]:text-secondary-800 [.disabled]:opacity-50 [.disabled]:pointer-events-none transition-colors"
              [class.active]="selection.isSelected(group)"
              [class.disabled]="isFolderDisabled(group)"
              (click)="selectFolder(group)"
              (dblclick)="navigateNext(group)"
              role="presentation"
            >
              <div class="flex flex-auto items-center overflow-hidden gap-2">
                <mat-icon>folder</mat-icon>

                <div class="flex-auto pr-2 font-medium text-sm truncate">
                  <span [matTooltip]="group.label">{{ group.label }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || !canSave() || !currentlySelected().length"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Verplaatsen</span>
  </button>
</mat-dialog-actions>
